module.exports = __webpack_public_path__ + "img/Instagram_icon.184e8e6.svg";